import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MultiselectDropdownModule } from 'angular-2-dropdown-multiselect';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { MaskedTextBoxModule, NumericTextBoxAllModule, NumericTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { ColumnChooserService, FilterService, GridModule, PageService, ResizeService, SortService } from '@syncfusion/ej2-angular-grids';
import { LovComponent } from './lov.component';
import { LovService } from './lov.service';
import { LovRoutingModule } from './lov-routing.module';

@NgModule({
  declarations: [
    LovComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    GridModule,
    NgSelectModule,
    MultiselectDropdownModule,
    NumericTextBoxModule,
    NumericTextBoxAllModule,
     NgxUiLoaderModule,
    MaskedTextBoxModule,
    LovRoutingModule

  ],
  providers: [LovService,ColumnChooserService,PageService,SortService,FilterService,ResizeService],
})
export class LovModule { }
